import Data from 'react-k2-api/Api/Data'
import { Type } from 'class-transformer'
import TArticleKindDM from './TArticleKindDM'

/**
 * Položky kalkulačních vzorců
 */
export default class TCalculationModelItemDM extends Data {
	public static className = 'TCalculationModelItemDM'
	public static systemFields = [
		'RecordID',
	]

	public static isHeader = false

	/**
	 * Připočíst režii
	 */
	AddOverheads?: string

	/**
	 * Pořadí
	 */
	SequenceNumber?: number

	/**
	 * Číslo
	 */
	Id?: number

	/**
	 * undefined
	 */
	RecordMod?: number

	/**
	 * undefined
	 */
	RecordES?: number

	/**
	 * Pořadí
	 */
	RecordID?: number

	/**
	 * undefined
	 */
	RecordState?: number

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * P
	 */
	OverheadImgCalc?: string

	/**
	 * Druh
	 */
	@Type(() => TArticleKindDM)
	ArticleCategoryId?: TArticleKindDM
}